<template>
  <div>
    <div class="content-devx">
      <DxForm>
        <DxGroupItem
          :caption="$t('registerProject.title_groupItem_crop')"
          :col-count="1"
        />
      </DxForm>
    </div>
    <div class="content-devx transparent content-table">
      <div class="table">
        <f7-row>
          {{ 'CULTIVOS AIRE LIBRE' }}
        </f7-row>
        <f7-row
          v-for="(crop, index) in listCrop"
          :key="index"
        >
          {{ crop.name }}
        </f7-row>
      </div>
    </div>
  </div>
</template>

<script>
import { DxForm, DxGroupItem } from 'devextreme-vue/form';

export default {
  name: 'FloorOpenAir',
  components: {
    DxForm,
    DxGroupItem,
  },
  props: {
    listCrop: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onChangeProvince() {

    },
    onChangeManure() {

    },
  },
};
</script>
<style lang="scss" scoped>
  @import url('../cropOpenAir/cropOpenAir.scss');
  .content-table {
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
  }
  .table {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    align-content: center;
    justify-content: center;
    width: 90%;
  }
  .row {
    border: 0.5px solid #c2c2c2;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    max-width: 400px;
    width: 100%;
    padding: 0.5rem;
    background-color: white;
  }
  .row:first-child{
    margin-bottom: 10px;
    background: var(--veg-green);
    color: white;
    text-transform: uppercase;
  }
  </style>
